export default __webpack_public_path__ + "static/media/linkedin.837d73bc.svg";